export default "__VITE_ASSET__tprpW2DQ7716zBOy1ARFww__"